'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { FactsSectionCardModel } from '../../types'

type Props = { props: FactsSectionCardModel }

const FactsSectionCard = ({ props: { image, text } }: Props) => {
  const translate = useTranslate()

  return (
    <article className="secondhand-taxes__facts-card">
      <div className="secondhand-taxes__facts-card-image">
        <Image src={image.src} srcset={image.srcSet} />
      </div>
      <p className="secondhand-taxes__facts-card-caption">{translate(text.caption)}</p>
      <p className="secondhand-taxes__facts-card-title">{translate(text.title)}</p>
    </article>
  )
}

export default FactsSectionCard
